import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModalWithTimer } from 'actions/appAction';

import PromoModalComponent from './PromoModalComponent';
import { PromoInfoPage } from '../common/PromoInfoPage/PromoInfoPage';

const PromoModalWithTimer = (props) => {
    const timerId = useRef(null);

    useEffect(() => {
        if (!timerId.current) {
            const closeModal = () => {
                if (props.onClick) {
                    props.onClick();
                } else if (props.onClose) {
                    props.onClose();
                } else {
                    props.toggleModalWithTimer(false, '', false);
                }
            };
            timerId.current = setTimeout(closeModal, 2000);
        }
        return () => clearTimeout(timerId.current);
    }, []);
    return (
        <PromoModalComponent canCloseModal={false} isVerticalCentered>
            <PromoInfoPage animatedIconSuccess mainText={props.message || props.text} insideModalComponent />
        </PromoModalComponent>
    );
};
PromoModalWithTimer.propTypes = {
    message: PropTypes.string, // props for action toggleModalWithTimer
    text: PropTypes.string, // props for ModalWithTimer component
    onClick: PropTypes.func, // props for ModalWithTimer component
    onClose: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]), // props for action  toggleModalWithTimer
};
const mapStateToProps = (state) => {
    return {
        message: state.app.messageForModalWithTimer,
        onClose: state.app.onCloseForModalWithTimer,
    };
};
export default connect(mapStateToProps, { toggleModalWithTimer })(PromoModalWithTimer);
